import type { Guide } from "../../types";
import type { LayoutLoad } from "./$types";
import { gql, request } from "../../data/client";

const query = gql(`
  query {
    guides {
      id
      title
      description(markdown: true)
      coverImage
      coverColor
      coverTextColor
      includeIndexPage
      indexTitle
      indexDescription(markdown: true)

      spots {
        id
        title
        showMap
        isCompletable
        description(markdown: true)
        mapId
        position
      }
    }
  }
`);

export const load: LayoutLoad = async function ({ fetch, url }) {
  const { guides } = await request(fetch, { url, query });

  return {
    guides: guides as Guide[]
  };
};
